import React, { useState, useEffect } from 'react';
import { collection, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase'; // Adjust according to your Firebase setup
import './styles/ManageStatDom.css';
import NavbarAdmin from '../components/NavbarAdmin';

const ManageRefLegal = () => {
  const [refs, setRefs] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({
    titre: '',
    lien: ''
  });

  useEffect(() => {
    const fetchRefs = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'ref_legal'));
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setRefs(data);
      } catch (error) {
        console.error("Error fetching references: ", error);
        alert("An error occurred while fetching references.");
      }
    };

    fetchRefs();
  }, []);

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData(prevData => ({ ...prevData, [name]: value }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const docRef = doc(db, 'ref_legal', editId);
      await updateDoc(docRef, editData);
      alert("Reference updated successfully!");
      setEditId(null);
      setEditData({
        titre: '',
        lien: ''
      });
      // Update the state directly
      setRefs(prevRefs =>
        prevRefs.map(ref =>
          ref.id === editId ? { ...ref, ...editData } : ref
        )
      );
    } catch (error) {
      console.error("Error updating reference: ", error);
      alert("An error occurred while updating the reference.");
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Êtes-vous sûr de vouloir supprimer cet élément ?");
    if (confirmDelete) {
      try {
        await deleteDoc(doc(db, 'ref_legal', id));
        alert("Reference deleted successfully!");
        // Remove deleted reference from state
        setRefs(prevRefs => prevRefs.filter(ref => ref.id !== id));
      } catch (error) {
        console.error("Error deleting reference: ", error);
        alert("An error occurred while deleting the reference.");
      }
    }
  };

  const headingStyle = {
    fontSize: '2rem',
    color: '#cc6699',
    fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
    margin: '20px 0',
    textAlign: 'center',
    borderBottom: '2px solid #ddd',
    paddingBottom: '10px'
  };

  const inputStyle = {
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ddd',
    width: '100%',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#6699CC',
    border: 'none',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '1rem',
    cursor: 'pointer',
  };

  const formStyle = {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    maxWidth: '600px',
    margin: '0 auto',
  };

  return (
    <div>
      <NavbarAdmin />
      <div className="manage-statistics">
        <h2 style={headingStyle}>Gérer les Références Juridiques</h2>
        <table>
          <thead>
            <tr>
              <th>Titre</th>
              <th>Lien Drive</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {refs.map(ref => (
              <tr key={ref.id}>
                <td>{ref.titre}</td>
                <td>{ref.lien}</td>
                <td>
                  <button
                    className="modifier"
                    onClick={() => {
                      setEditId(ref.id);
                      setEditData({
                        titre: ref.titre,
                        lien: ref.lien
                      });
                    }}
                  >
                    Modifier
                  </button>
                  &nbsp;&nbsp;
                  <button
                    className="supprimer"
                    onClick={() => handleDelete(ref.id)}
                  >
                    Supprimer
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {editId && (
          <form onSubmit={handleEditSubmit} style={formStyle}>
            <h3 style={{ color: '#6699CC' }}>Modifier la référence juridique</h3>
            <label>
              Titre:
              <input
                type="text"
                name="titre"
                value={editData.titre}
                onChange={handleEditChange}
                required
                style={inputStyle}
              />
            </label>
            <br />
            <label>
              Lien Drive:
              <input
                type="text"
                name="lien"
                value={editData.lien}
                onChange={handleEditChange}
                required
                style={inputStyle}
              />
            </label>
            <br />
            <button type="submit" style={buttonStyle}>Mettre à jour</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ManageRefLegal;
